var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.displaySummaryTime
        ? _c("summary-time", {
            attrs: {
              "frequency-form": _vm.frequencyForm,
              "start-date": _vm.frequencyForm.startDay,
              time: _vm.frequencyForm.runningTime,
              timezone: _vm.frequencyForm.timezone,
              "selected-holidays": _vm.selectedHolidays,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "trigger-file-field",
        _vm._g(
          {
            staticClass: "frequency-content__trigger-file",
            attrs: { "display-trigger-file": _vm.displayTriggerFile },
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }